import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '首页', path: '/' },
    { label: '分类浏览', path: '/category' },
    { label: '关于我们', path: '/about' },
    { label: '下载指南', path: '/article/2' },
  ],
  热门分类: [
    { label: '恋爱韩漫', path: '/category?tab=romance' },
    { label: '奇幻韩漫', path: '/category?tab=fantasy' },
    { label: '热血韩漫', path: '/category?tab=action' },
    { label: 'BL韩漫', path: '/category?tab=bl' },
  ],
  帮助支持: [
    { label: 'APK安装教程', path: '/article/5' },
    { label: '离线下载指南', path: '/article/2' },
    { label: 'APP推荐', path: '/article/1' },
    { label: '常见问题', path: '/#faq' },
  ],
  联系方式: [
    { label: '微信公众号：韩漫之家', path: '#', isText: true },
    { label: 'QQ群：888888888', path: '#', isText: true },
    { label: '邮箱：contact@hanmanzhijia.com', path: '#', isText: true },
    { label: '客服时间：9:00-21:00', path: '#', isText: true },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold mb-4 opacity-90 whitespace-nowrap">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) =>
                  link.isText ? (
                    <li
                      key={link.label}
                      className="text-sm opacity-70 hover:opacity-100 transition-opacity duration-200"
                    >
                      {link.label}
                    </li>
                  ) : (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        className="text-sm opacity-70 hover:opacity-100 transition-opacity duration-200 whitespace-nowrap"
                      >
                        {link.label}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-50/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link
            to="/"
            className="text-lg font-heading font-bold tracking-wide whitespace-nowrap"
          >
            韩漫之家
          </Link>
          <p className="text-sm opacity-60 text-center">
            &copy; {new Date().getFullYear()} 韩漫之家. 韩漫下载安装与韩漫离线免费下载平台
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-all duration-200 cursor-pointer"
              rel="nofollow"
            >
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-all duration-200 cursor-pointer"
              rel="nofollow"
            >
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-all duration-200 cursor-pointer"
              rel="nofollow"
            >
              <i className="ri-bilibili-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}